import React from 'react';

interface SectionAnchorProps {
  value: {
    sectionId: string;
  };
}

function BlockBuilderSectionAnchor({ value }: Readonly<SectionAnchorProps>) {
  return (
    <div
      id={`section-id-${value.sectionId}`}
      style={{
        position: 'relative',
      }}
    />
  );
}
export default BlockBuilderSectionAnchor;
